import { createFileRoute } from "@tanstack/react-router";
import Page from "@/pages/contact";
import { contactJsonLd } from "@/pages/contact.seo";

import { brand } from "@/config/brand";
const SITE_URL = brand.url;
const OG_IMAGE = `${SITE_URL}/__l5e/assets-v1/aabeccab-688e-44b7-96b1-aaf70d6a2a8d/social-share-cover.png`;
const OG_ALT = "Digitally Baffled LTD — UK Digital Transformation Consultancy";

export const Route = createFileRoute("/contact")({
  head: () => ({
    meta: [
      { title: "Contact Us | Digitally Baffled" },
      {
        name: "description",
        content:
          "Contact Digitally Baffled — phone, email, or WhatsApp. Based in Ringwood, Hampshire. Free 30-minute discovery call available. No obligation, no jargon.",
      },
      { property: "og:site_name", content: "Digitally Baffled" },
      { property: "og:title", content: "Contact Us — Digitally Baffled" },
      {
        property: "og:description",
        content:
          "Get in touch with Digitally Baffled — by phone, email, WhatsApp, or social media. We're here to help your business grow digitally.",
      },
      { property: "og:url", content: `${SITE_URL}/contact` },
      { property: "og:type", content: "website" },
      { property: "og:image", content: OG_IMAGE },
      { property: "og:image:secure_url", content: OG_IMAGE },
      { property: "og:image:type", content: "image/png" },
      { property: "og:image:width", content: "1200" },
      { property: "og:image:height", content: "630" },
      { property: "og:image:alt", content: OG_ALT },
      { property: "og:locale", content: "en_GB" },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:site", content: "@digitallybaffld" },
      { name: "twitter:creator", content: "@digitallybaffld" },
      { name: "twitter:title", content: "Contact Us — Digitally Baffled" },
      {
        name: "twitter:description",
        content: "Get in touch with Digitally Baffled — by phone, email, WhatsApp, or social media.",
      },
      { name: "twitter:image", content: OG_IMAGE },
      { name: "twitter:image:alt", content: OG_ALT },
    ],
    links: [{ rel: "canonical", href: `${SITE_URL}/contact` }],
    scripts: [{ type: "application/ld+json", children: JSON.stringify(contactJsonLd) }],
  }),
  component: Page,
});
